






























import { SharedState } from "@/common/state";
import { onBeforeUnmount, onMounted } from "@vue/composition-api";
import Vue from "vue";
import { state } from "./data/state";
import Processing from "@/components/table/Processing.vue";
import PageWithMainContainer from "@/components/PageWithMainContainer.vue";
import SimpleNavTabs from "@/components/SimpleNavTabs.vue";
import PlaybooksAudit from "./audit/PlaybooksAudit.vue";
import Playbooks from "./Playbooks.vue";
export default Vue.extend({
  components: {
    Processing,
    PageWithMainContainer,
    SimpleNavTabs,
    PlaybooksAudit,
    Playbooks,
  },
  setup() {
    const { is_loading, init, tabs, selected_tab, set_selected_tab } = state;

    onMounted(() => {
      SharedState.onReady(async () => {
        await init();
      });
    });

    onBeforeUnmount(() => state.on_destroy());

    return {
      is_loading,
      tabs,
      selected_tab,
      set_selected_tab,
    };
  },
});
